<p class="quote-content">{{ component()?.content }}</p>
